export const StoreScheduleEntryBlockedType: {
    BREAK: "BREAK",
    VACATION: "VACATION",
    MEETING: "MEETING",
    SICK_LEAVE: "SICK_LEAVE",
    EDUCATION: "EDUCATION",
    OTHER: "OTHER",
} = {
    BREAK: "BREAK",
    VACATION: "VACATION",
    MEETING: "MEETING",
    SICK_LEAVE: "SICK_LEAVE",
    EDUCATION: "EDUCATION",
    OTHER: "OTHER",
};

export type StoreScheduleEntryBlockedType = (typeof StoreScheduleEntryBlockedType)[keyof typeof StoreScheduleEntryBlockedType]